var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Favorite_svg__clip0_1271_29047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5c-.22 0-.437-.032-.646-.094L9.33 17.4a12.899 12.899 0 01-4.707-3.103 9.758 9.758 0 01-2.958-6.868 4.9 4.9 0 01.807-2.734A4.867 4.867 0 0110 3.934a4.88 4.88 0 015.335-1.051A4.887 4.887 0 0117.524 4.7c.533.81.815 1.76.809 2.73a9.779 9.779 0 01-2.958 6.867 12.899 12.899 0 01-4.707 3.102l-.023.007c-.21.062-.427.094-.645.094zm-.305-1.208c.2.056.41.056.61 0 1.795-.622 6.866-3.56 6.866-8.86v-.005a3.737 3.737 0 00-.694-2.193 3.722 3.722 0 00-4.138-1.391 3.72 3.72 0 00-1.872 1.33.583.583 0 01-.935 0 3.721 3.721 0 00-4.165-1.306 3.722 3.722 0 00-1.844 1.368 3.737 3.737 0 00-.694 2.192c0 5.306 5.07 8.247 6.866 8.865z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Favorite_svg__clip0_1271_29047"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.666 2.5)",
    d: "M0 0h16.667v15H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Favorite.68209d00.svg";
export { SvgFavorite as ReactComponent };